const moveRechargeWidget = () => {
  const rechargeWidget = document.querySelector('.recharge-subscription-widget');
  if (!rechargeWidget) return;
  // remove the recharge widget from the parent
  const parent = rechargeWidget.parentElement;
  if (!parent) return;
  parent.removeChild(rechargeWidget);
  // insert the recharge widget just before .main-product__qty-add
  const qtyAdd = document.querySelector('.main-product__qty-add');
  if (!qtyAdd) return;
  qtyAdd.parentElement.insertBefore(rechargeWidget, qtyAdd);
  const label = '<span class="form__label">Frequency</span>';
  rechargeWidget.insertAdjacentHTML('beforebegin', label);
};

document.addEventListener('DOMContentLoaded', moveRechargeWidget);
